import { initializeApp } from 'firebase/app';
import {
  connectFunctionsEmulator,
  getFunctions,
  Functions,
  httpsCallable,
} from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyDG_Xdlt6gyYdR_lH66_K8zaqrI_e574ko',
  authDomain: 'breakfast-8ac2d.firebaseapp.com',
  projectId: 'breakfast-8ac2d',
  storageBucket: 'breakfast-8ac2d.appspot.com',
  messagingSenderId: '423798668073',
  appId: '1:423798668073:web:816d57444ced42a2ae1538',
  measurementId: 'G-66059JGPQV',
};

const app = initializeApp(firebaseConfig);
const functions: Functions = getFunctions(app, 'us-central1');

if (
  process.env.NODE_ENV === 'development' &&
  import.meta.env.VITE_APP_USE_FIREBASE_EMULATORS == 'true'
) {
  const host = import.meta.env.VITE_APP_FIREBASE_EMULATOR_HOST ?? '127.0.0.1';
  const functionsPort =
    import.meta.env.VITE_APP_FIREBASE_FUNCTIONS_EMULATOR_PORT ?? '5001';

  console.info(`Practist 'public' app is using Firebase emulators`);
  console.log(`Functions emulator: http://${host}:${functionsPort}`);

  connectFunctionsEmulator(functions, host, parseInt(functionsPort, 10));
}

export { app, functions, httpsCallable };
